import { render, staticRenderFns } from "./AdyenOrderPaymentOptions.vue?vue&type=template&id=852bfd0c"
import script from "./AdyenOrderPaymentOptions.vue?vue&type=script&lang=js"
export * from "./AdyenOrderPaymentOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports